import moment from 'moment'

export default {
    install(Vue, options) {

        const optionsDefaults = {}

        // Merge options argument into options defaults
        options = {
            ...optionsDefaults,
            ...options
        }

        Vue.mixin({
            methods: {
                moment: function () {
                    return moment();
                }
            }
        });
    }
}